import {fetchJSONByPost} from '@/apis'

export const uploadApi = (body) => fetchJSONByPost('/adms_api_v0/shopify/upload', body)
export const updateApi = (body) => fetchJSONByPost('/adms_api_v0/shopify/product/update', body)
export const delSpuApi = (body) => fetchJSONByPost('/adms_api_v0/shopify/product/remove', body)
export const delSkuApi = (body) => fetchJSONByPost('/adms_api_v0/shopify/variant/remove', body)